<script>
import table from './log.table'
import startCase from 'lodash/startCase'
import getExportedFilename from '@lib/utils/get-exported-filename'
import OfferMixin from '../offer/offer.mixin'
import LogList from './log-list'
import { formatDate } from '@lib/utils/format-date'
import get from 'lodash/get'

export default {
  name: 'Log',
  page: {
    title: 'Log',
  },
  components: {
    LogList,
  },
  mixins: [OfferMixin],
  data() {
    return {
      table: table(this),
    }
  },
  methods: {
    startCase,
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
    fields(row) {
      const { entityType, action } = row

      switch (entityType) {
        case 'Retailer':
          return {
            fields: [
              {
                name: 'active',
                title: 'Status',
                slot: 'status',
              },
              {
                name: 'name',
                title: 'Name',
                template(value, field, row) {
                  return action === 'delete' ? get(row, 'meta.retailer.name') : value
                },
              },
              'description',
              'website',
              'logo',
            ],
          }
        case 'Offer':
          return {
            fields: [
              {
                name: 'active',
                title: 'Status',
                slot: 'status',
              },
              {
                name: 'name',
                title: 'Offer Name',
                template(value, field, row) {
                  return action === 'delete' ? get(row, 'meta.offer.name') : value
                },
              },
              {
                name: 'retailer',
                title: 'Retailer',
                template(value, field, row) {
                  return action === 'delete' ? get(row, 'meta.retailer.name') : null
                },
              },
              {
                name: 'categories',
                title: 'Category',
                template: value => {
                  return value && value.length ? value.map(category => category.name).join(', ') : null
                },
              },
              {
                name: 'description',
                title: 'Offer Description',
              },
              {
                name: 'locations',
                title: 'Participating Locations',
                slot: 'locations',
              },
              {
                name: 'endsAt',
                title: 'Offer End Date',
                template(value) {
                  return value ? formatDate(value.date, 'DD/MM/YYYY') : null
                },
              },
              {
                name: 'terms',
                title: 'Offer Terms and Conditions',
              },
              {
                name: 'type',
                title: 'Offer Type',
                template: value => {
                  return value ? this.offerTypeName(value) : null
                },
              },
              {
                name: 'couponType',
                template: value => {
                  return value ? this.couponTypeName(value) : null
                },
              },
              'couponCode',
              'promotionUrl',
              'redemptionImage',
            ],
          }
        case 'Category': return { fields: ['name'] }
        default:
          return {}
      }
    },
    formatDate(value, format) {
      return formatDate(value, format || 'DD/MM/YYYY')
    },
  },
}
</script>

<template>
  <main-layout title="Log">
    <table-layout
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :fragments="false"
      :quantity="[25, 50, 100, 200]"
      :export-filename="getExportedFilename"
      :multisort="false"
      hider-header-visible
    >
      <template
        slot="expandedRow"
        slot-scope="{ row, columns }"
      >
        <log-list
          v-if="fields(row)"
          :columns="columns"
          :data="row.data"
          :config="fields(row)"
        >
          <status
            slot="status"
            slot-scope="{ value }"
            :status="value"
          />
          <template
            v-if="value && value.length"
            slot="locations"
            slot-scope="{ value }"
          >
            <span
              v-for="(location, idx) in value"
              :key="idx"
              :class="$style.location"
            >
              {{ location.name }}
            </span>
          </template>
        </log-list>
      </template>
    </table-layout>
  </main-layout>
</template>

<style lang="scss" module>
  .location {
    display: block;

    & + & {
      margin-top: rem(5px);
    }
  }
</style>
